import util from "@/utils/util.js";

import { login, logout, getInfo } from "@/api/login";
import { getToken, setToken, removeToken, setUserInfo } from "@/utils/auth";

const user = {
  state: {
    userInfo: util.getUser(),
    token: getToken(),
    name: "",
    avatar: "",
    roles: [],
    permissions: [],
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions;
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.userName.trim();
      const password = userInfo.password;
      return new Promise((resolve, reject) => {
        login(username, password)
          .then((res) => {
            // sessionStorage.setItem('')
            setToken(res.data.data.token);
            setUserInfo(userInfo);
            commit("SET_TOKEN", res.token);
            commit("setUserInfo", userInfo);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token)
          .then((res) => {
            const user = res.data.data.user;
            const avatar =
              user.avatar == ""
                ? require("@/assets/img/login/profile.jpg")
                : process.env.VUE_APP_BASE_API + user.avatar;
            if (res.data.data.roles && res.data.data.roles.length > 0) {
              // 验证返回的roles是否是一个非空数组
              commit("SET_ROLES", res.data.data.roles);
              commit("SET_PERMISSIONS", res.data.data.permissions);
            } else {
              commit("SET_ROLES", ["ROLE_DEFAULT"]);
            }
            commit("SET_NAME", user.userName);
            commit("SET_AVATAR", avatar);
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit("SET_TOKEN", "");
            commit("SET_ROLES", []);
            commit("SET_PERMISSIONS", []);
            commit("SET_ROUTERS", "");
            commit("SET_SERVER_ROUTER", "");
            removeToken();
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js